import { toast } from 'react-hot-toast'
import { WSChatMessage, WSFriendsGameInviteMessage, WSFriendsUpdateMessage } from 'mvppoker-portal-common/api'
import { store } from '../state/AppStore'
import { updateUserFriends } from '../state/reducers/activeUser'
import { addChatMessage, setGameInvite, setLastUnreadChat } from '../state/reducers/ProfileDataReducer'
import { websocketConnection } from './websockets/Websockets'

class FriendsService
{
    setup()
    {
        websocketConnection.listenToFriends(this.handleFriendsUpdate, this.handleFriendsChat, this.handleFriendsGameInvite)
    }
    
	cleanup()
	{
		websocketConnection.stopListenToFriends()
	}

    sendFriendsChat(message: string, friendId: string)
    {
        const { user } = store.getState().activeUser
		if (user === undefined) { return }

		const m : WSChatMessage = {
			fromId: user.id,
			toId: friendId,
			message,
			timestamp: Date.now()
		}

        store.dispatch(addChatMessage([friendId, m, true]))
		
        websocketConnection.sendFriendsChat(m)
    }

    sendFriendsGameInvite(friendId: string)
    {
        const user = store.getState().activeUser.user!
        const game = store.getState().activeGame.game!

		const invite : WSFriendsGameInviteMessage = {
			fromId: user!.id,
			toId: friendId,
			roomId: game!.id
		}

        websocketConnection.sendFriendsGameInvite(invite)
    }

    private handleFriendsUpdate(update: WSFriendsUpdateMessage)
    {
        const { user } = store.getState().activeUser
		if (user === undefined) { return }

		const newFriends = update.friends.friends.length - user.friends.friends.length
		const newRequests = update.friends.requestsReceived.length - user.friends.requestsReceived.length

		store.dispatch(updateUserFriends(update.friends))

        if (newFriends > 0) {
            // TODO:
//            gameAudioService.play(GameAudioService.FRIENDS_ACCEPTED)
			toast.success('NEW FRIEND ADDED!')
        } else if (newRequests > 0) {
            // TODO:
//            gameAudioService.play(GameAudioService.FRIENDS_INVITED)
			toast.success('YOU HAVE A FRIEND INVITE!')
        }
    }

    private handleFriendsChat(chatMessage: WSChatMessage)
    {
        const { user } = store.getState().activeUser
		if (user === undefined){ return }

        store.dispatch(addChatMessage([chatMessage.fromId, chatMessage, false]))
        store.dispatch(setLastUnreadChat(chatMessage))

        // TODO:
//            gameAudioService.play(GameAudioService.FRIENDS_CHAT)
    }

    private handleFriendsGameInvite(invite: WSFriendsGameInviteMessage)
    {
        const { user } = store.getState().activeUser
		if (user === undefined){ return }
		
        store.dispatch(setGameInvite(invite))

        // TODO:
//            gameAudioService.play(GameAudioService.FRIENDS_GAMEINVITE)
    }
}

export const friendsService = new FriendsService()
